module.exports = ".countdown-timer {\n  font-size: 16px;\n}\n\n.countdown-timer strong {\n  font-size: 18px;\n}\n"